import { createReducer, on } from '@ngrx/store';
import {
  dataExportComponentActions,
  dataExportServiceActions,
} from './data-export.actions';

export enum DataExportStatus {
  idle,
  downloading,
  error,
}

export interface DataExportUiState {
  bibliographicDataStatus: DataExportStatus;
  screeningDataStatus: DataExportStatus;
  annotationDataStatus: DataExportStatus;
  quantitativeDataStatus: DataExportStatus;
}

const initialState: DataExportUiState = {
  bibliographicDataStatus: DataExportStatus.idle,
  screeningDataStatus: DataExportStatus.idle,
  annotationDataStatus: DataExportStatus.idle,
  quantitativeDataStatus: DataExportStatus.idle,
};

export const dataExportReducer = createReducer(
  initialState,
  on(dataExportComponentActions.getBibliographicData, (state) => ({
    ...state,
    bibliographicDataStatus: DataExportStatus.downloading,
  })),
  on(dataExportComponentActions.getScreeningData, (state) => ({
    ...state,
    screeningDataStatus: DataExportStatus.downloading,
  })),
  on(dataExportComponentActions.getAnnotationData, (state) => ({
    ...state,
    annotationDataStatus: DataExportStatus.downloading,
  })),
  on(dataExportComponentActions.getQuantitativeData, (state) => ({
    ...state,
    quantitativeDataStatus: DataExportStatus.downloading,
  })),
  on(dataExportServiceActions.bibliographicDataReceived, (state) => ({
    ...state,
    bibliographicDataStatus: DataExportStatus.idle,
  })),
  on(dataExportServiceActions.screeningDataReceived, (state) => ({
    ...state,
    screeningDataStatus: DataExportStatus.idle,
  })),
  on(dataExportServiceActions.annotationDataReceived, (state) => ({
    ...state,
    annotationDataStatus: DataExportStatus.idle,
  })),
  on(dataExportServiceActions.quantitativeDataReceived, (state) => ({
    ...state,
    quantitativeDataStatus: DataExportStatus.idle,
  })),
  on(dataExportServiceActions.bibliographicDataError, (state) => ({
    ...state,
    bibliographicDataStatus: DataExportStatus.error,
  })),
  on(dataExportServiceActions.screeningDataError, (state) => ({
    ...state,
    screeningDataStatus: DataExportStatus.error,
  })),
  on(dataExportServiceActions.annotationDataError, (state) => ({
    ...state,
    annotationDataStatus: DataExportStatus.error,
  })),
  on(dataExportServiceActions.quantitativeDataError, (state) => ({
    ...state,
    quantitativeDataStatus: DataExportStatus.error,
  }))
);
